import React, {useEffect, useState} from 'react';
import * as Yup from 'yup';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import './styles.scss';
import {compose} from 'redux';
import * as fonts from '../../util/fonts';
import AppButton from '../../components/app-button';
import Header1 from '../../components/headers/header1';
import Icon from '../../components/icon';
import {Column, Row} from '../../components/layout';
import {
  addToGlobalStyles,
  addToWizard,
  setIban,
  setIbanFilterOpenTrigger,
  setSelectedBu,
  setTitular,
  setUpdateRoutesNewSelectedPatient,
} from '../../store/actions';
import colors from '../../util/colors';
import {Icons} from '../../util/icons';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import {AppForm, AppFormSelectField} from '../../components/forms';
import {get} from '../../api/api';
import {
  uriGetProductMembers,
  uriMemberData,
  uriGetThirdPartyAuthorizedUsers,
} from '../../api/endpoints';
import {getUserMemId, numberWithSpaces} from '../../util/utility';
import IbanFilter from './iban-filter';
import moment from 'moment';
import AppSpinner from '../../components/app-spinner';
import {useLocation} from 'react-router-dom';
import InternationalMyInfoData from './my-info-int/InternationalMyInfoData';
import AppSimpleAccordion from '../../components/app-simple-accordion';
import ModalTemplate from '../../components/modal';

const validationSchema = Yup.object().shape({});

interface MyDataProps {
  user: any;
  addToGlobalStyles(value: any): void;
  setIbanFilterOpenTrigger(value: any): void;
  setSelectedBu(value: any): void;
  setUpdateRoutesNewSelectedPatient(): void;
  ibanFilter: any;
  selectedBu: any;
  labels: typeof strings.pt.myData;
  labelsCreateRefund: typeof strings.pt.createRefund;
  addToWizard(value: any): void;
  buStyles: any;
  busFuncMap: any;
  setIban: typeof setIban;
  setTitular: typeof setTitular;
  availableBus: any;
  titular: any;
  iban: any;
  busMap: any;
  ibanStrings: any;
  busGroupExceptions: any;
  updateRoutesNewSelectedPatient: any;
  bankAccountDataHolder: any;
  userBankAccountDataWasUpdated: boolean;
  servicesLabels: typeof strings.pt.services;
}

function MyData({
  user,
  selectedBu,
  labels,
  ibanFilter,
  setIbanFilterOpenTrigger,
  setSelectedBu,
  setUpdateRoutesNewSelectedPatient,
  buStyles,
  busFuncMap,
  setIban,
  setTitular,
  availableBus,
  titular,
  iban,
  busMap,
  ibanStrings,
  busGroupExceptions,
  updateRoutesNewSelectedPatient,
  bankAccountDataHolder,
  userBankAccountDataWasUpdated,
  servicesLabels,
}: MyDataProps) {
  const history = useHistory();
  const location: any = useLocation();
  const [insurancePersons, setInsurancePersons] = useState<any[]>([]);
  const [selectedInsurancePerson, setselectedInsurancePerson] =
    useState<any>(selectedBu);
  const [selectedInsuranceData, setSelectedInsuranceData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showIban, setshowIban] = useState(ibanFilter.ibanFilter);
  const [showIbanPatientSelected, setShowIbanPatientSelected] = useState(false);
  const [userData, setUserData] = useState<any>();
  const [insurancePerson, setInsurancePerson] = useState(selectedBu.memberName);
  const [insurancePersonOptions, setInsurancePersonOptions] = useState<any>([]);
  const [formikContext, setFormikContext] = useState<any>();
  const [notAuth, setNotAuth] = useState(false);
  const [memId, setMemId] = useState('');
  const [multicode, setMulticode] = useState('');
  const [canSubmit, setCanSubmit] = useState(false);
  const [preventOnChange, setPreventOnChange] = useState(false);
  const [showError, setShowError] = useState(false);

  const featureName = 'MyData';

  const handleFormikContext = (formik: any) => {
    if (!!!formikContext) {
      setFormikContext(formik);
    }
  };
  const updateSelectedCard = () => {
    localStorage.setItem('BuId', location?.state?.patientSelected?.buId);
    const completeSelectedBu = busMap?.[selectedBu?.buId]?.[
      selectedBu?.famId
    ]?.find((el: any) => {
      return el.memId === location?.state?.patientSelected?.memId;
    });
    setSelectedBu(completeSelectedBu);
    // window.history.replaceState({}, '');
    setUpdateRoutesNewSelectedPatient();
  };

  const groupIdExceptionMap = busGroupExceptions?.filter(
    (exception: any) => exception.buAlias === selectedBu.buId
  );

  const grpIdObject = groupIdExceptionMap?.find(
    (obj: any) => obj.groupId === selectedBu.grpId
  );

  const myDataFooterContactFromGroupId =
    grpIdObject?.groupExceptionDetails[0].myInsuranceDataFooterContact;

  const isTitular = () => {
    if (ibanStrings?.ibanRefunds_ibanIsEnabled !== '1') {
      setCanSubmit(false);
    } else {
      if (
        bankAccountDataHolder === 'SUBSCRIBER'
          ? titular?.nif === user?.nif && titular?.buId === selectedBu?.buId
          : true
      ) {
        setCanSubmit(true);
      } else {
        setCanSubmit(false);
      }
    }
  };

  const handleSelectedPerson = (id: string) => {
    insurancePersons.map((person) => {
      if (person.id == id) {
        setselectedInsurancePerson(person);
      }
    });
  };

  useEffect(() => {
    setPreventOnChange(true);
    setInsurancePerson(selectedBu?.memberName);
  }, [selectedBu?.memberName]);

  const handleSelectedDataChange = (insurancePerson: any) => {
    async function getSelectedInsuranceData() {
      setIsLoading(true);
      try {
        await get(
          uriMemberData(
            insurancePerson.buId,
            insurancePerson.memId,
            insurancePerson.famId
          ),
          false,
          0,
          featureName
        ).then((res: any) => {
          setSelectedInsuranceData(res?.data);
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
        });
        if (ibanStrings?.ibanRefunds_bankAccountDataHolder === 'SUBSCRIBER') {
          if (
            insurancePerson.memId === memId ||
            insurancePerson.memId === multicode ||
            (memId === '' && multicode === '')
          ) {
            setNotAuth(false);
          } else {
            get(
              uriGetThirdPartyAuthorizedUsers(
                selectedBu.buId,
                insurancePerson.memId,
                memId
              ),
              false,
              0,
              featureName
            ).then((authUsersRes: any) => {
              if (
                authUsersRes.data?.items[0] &&
                !authUsersRes.data?.items[0].authorized
              ) {
                setNotAuth(true);
              } else {
                setNotAuth(false);
              }
            });
          }
        }
        if (ibanStrings?.ibanRefunds_form === 'servio') {
          if (ibanStrings?.ibanRefunds_usePermissions == '1') {
            if (insurancePerson.nif === user?.nif) {
              setNotAuth(false);
            } else {
              get(
                uriGetThirdPartyAuthorizedUsers(
                  selectedBu.buId,
                  insurancePerson.memId,
                  memId
                ),
                false,
                0,
                featureName
              ).then((authUsersRes: any) => {
                if (
                  authUsersRes.data?.items[0] &&
                  !authUsersRes.data?.items[0].authorized
                ) {
                  setNotAuth(true);
                } else {
                  setNotAuth(false);
                }
              });
            }
          }
        }
      } catch (err: any) {
        setNotAuth(false);
        setShowError(true);
        setIsLoading(false);
      }
    }
    getSelectedInsuranceData();
  };

  useEffect(() => {
    isTitular();
  }, [ibanStrings?.ibanRefunds_ibanIsEnabled]);

  useEffect(() => {
    if (location?.state?.patientSelected) {
      setTimeout(() => {
        setIbanFilterOpenTrigger({ibanFilter: true});
        setShowIbanPatientSelected(true);
      }, 1000);
      selectedBu?.memId !== location?.state?.patientSelected?.memId &&
        updateSelectedCard();
    }
  }, [location?.state]);

  useEffect(() => {
    const loggedInsurancePerson = getUserMemId(availableBus, user, selectedBu);
    setshowIban(false); //close tooltip everytime card changes to prevent having the tooltip open when changing to a card with func inactive

    async function getInsurancePersonOptions() {
      const insurancePersonsGet = await get(
        uriGetProductMembers(user.nif, user.birthdate),
        false,
        0,
        featureName
      ).then((res: any) => {
        return res?.data?.items;
      });
      let newInsurances: any[] = [];
      let options: any[] = [];

      (insurancePersonsGet as any).map((insurancePerson: any) => {
        if (
          selectedBu.famId === insurancePerson.famId &&
          selectedBu.buId === insurancePerson.buId
        ) {
          insurancePerson.productList.map((person: any) => {
            if (person) {
              const id = person.memberName;
              newInsurances.push({...person, id});
              options.push({
                value: person.memberName,
                label: person.memberName,
              });
            }
          });
        }
      });

      setInsurancePersons(newInsurances);
      setselectedInsurancePerson(
        newInsurances?.find(
          (el: any) => el?.memberName == selectedBu?.memberName
        ) || newInsurances[0]
      );
      setInsurancePersonOptions(options);
      newInsurances.map(async (person) => {
        if (person.nif === user.nif) {
          setUserData(person);
          return true;
        }
        return false;
      });
    }
    setMemId(loggedInsurancePerson?.memId || '');
    setMulticode(loggedInsurancePerson.multicode);
    getInsurancePersonOptions();
    isTitular();
  }, [selectedBu.memId]);

  useEffect(() => {
    let filterPatients = insurancePersonOptions?.filter(
      (x: any) => x !== undefined
    );

    setInsurancePersonOptions(filterPatients);
  }, [insurancePersons]);

  useEffect(() => {
    !!selectedInsurancePerson &&
      handleSelectedDataChange(selectedInsurancePerson);
  }, [selectedInsurancePerson, userBankAccountDataWasUpdated]);

  useEffect(() => {
    handleSelectedPerson(insurancePerson);
  }, [insurancePerson]);

  useEffect(() => {
    if (titular) {
      isTitular();
    }
  }, [titular]);

  const handleHideIban = () => {
    setshowIban(false);
    setShowIbanPatientSelected(false);
    setIbanFilterOpenTrigger({ibanFilter: false});
  };

  const updateIban = (iban: string) => {
    setIban(iban);
    setTitular({...titular, iban: iban});
  };

  const renderSerbianForm = () => {
    return (
      <>
        {selectedInsuranceData && (
          <InternationalMyInfoData
            buStyles={buStyles}
            user={user}
            selectedInsuranceData={selectedInsuranceData}
            labels={labels}
            serviceLabels={servicesLabels}
            editable={ibanStrings?.ibanRefunds_ibanIsEnabled == '1'}
            noAuth={notAuth}
          />
        )}
        <div className="my-info-wrapper">
          <AppSimpleAccordion
            openByDefault={labels?.myData_insuranceDataExpanded == '1'}
            header={
              <div className="accordion-title-wrapper">
                <p style={{...fonts.M}}>
                  {labels?.myData_IntInsuranceDataHeader}
                </p>
              </div>
            }
            content={
              <>
                <Row className="my-data-personal-row-sr">
                  <Column className="my-data-personal-left-column">
                    <Row className="account-data-row-title">
                      <p className="m-0" style={{...fonts.SM}}>
                        {labels?.myData_fullName}
                      </p>
                    </Row>
                    <Row className="my-data-row-sr">
                      {selectedInsuranceData.name}
                    </Row>
                    <Row className="account-data-row-title">
                      <p className="m-0" style={{...fonts.SM}}>
                        {labels?.myData_dateOfBirth}
                      </p>
                    </Row>
                    <Row className="my-data-row-sr">
                      {moment(selectedInsuranceData.dob)
                        .format('DD-MM-YYYY')
                        .toUpperCase()}
                    </Row>
                    <Row className="account-data-row-title">
                      <p className="m-0" style={{...fonts.SM}}>
                        {labels?.myData_gender}
                      </p>
                    </Row>
                    <Row className="my-data-row-sr">
                      {selectedInsuranceData.genderCode}
                    </Row>
                    <Row className="account-data-row-title">
                      <p className="m-0" style={{...fonts.SM}}>
                        {labels?.myData_fiscalNumber}
                      </p>
                    </Row>
                    <Row className="my-data-row-sr">
                      {selectedInsurancePerson.nif}
                    </Row>
                  </Column>
                  <Column className="my-data-personal-right-column">
                    <Row className="account-data-row-title">
                      <p className="m-0" style={{...fonts.SM}}>
                        {labels?.myData_address}
                      </p>
                    </Row>
                    <Row className="my-data-row-sr">
                      {selectedInsuranceData.addr} <br />
                      {selectedInsuranceData.postalcode} <br />
                      {selectedInsuranceData.city}
                    </Row>
                    <Row className="account-data-row-title">
                      <p className="m-0" style={{...fonts.SM}}>
                        {labels?.myData_phone}
                      </p>
                    </Row>
                    <Row className="my-data-row-sr">
                      {numberWithSpaces(selectedInsuranceData.phone)}
                    </Row>
                    {labels?.myData_cellphone_show === '1' && (
                      <>
                        <Row className="account-data-row-title">
                          <p className="m-0" style={{...fonts.SM}}>
                            {labels?.myData_cellphone}
                          </p>
                        </Row>
                        <Row className="my-data-row-sr">
                          {numberWithSpaces(selectedInsuranceData.cellPhone)}
                        </Row>
                      </>
                    )}
                    <Row className="account-data-row-title">
                      <p className="m-0" style={{...fonts.SM}}>
                        {labels?.myData_email}
                      </p>
                    </Row>
                    <Row className="my-data-row-sr">
                      {selectedInsuranceData.email}
                    </Row>
                  </Column>
                </Row>
                <Column className="my-data-adicional-help">
                  <Row style={{...fonts.M, ...fonts.Bold}}>
                    {labels?.myData_incorrectData}
                  </Row>
                  <Row style={{...fonts.M, ...fonts.Bold}}>
                    {myDataFooterContactFromGroupId
                      ? myDataFooterContactFromGroupId
                      : labels?.myData_contact}
                  </Row>
                </Column>
              </>
            }
          />
        </div>
      </>
    );
  };

  const renderDefaultForm = () => {
    return (
      <>
        <Row className="my-data-personal-row">
          <Column className="my-data-personal-left-column">
            <Row className="account-data-row-title">
              <p className="m-0" style={{...fonts.SM}}>
                {labels?.myData_fullName}
              </p>
            </Row>
            <Row className="my-data-row">{selectedInsuranceData.name}</Row>
            <Row className="account-data-row-title">
              <p className="m-0" style={{...fonts.SM}}>
                {labels?.myData_dateOfBirth}
              </p>
            </Row>
            <Row className="my-data-row">
              {moment(selectedInsuranceData.dob)
                .format('DD-MM-YYYY')
                .toUpperCase()}
            </Row>
            <Row className="account-data-row-title">
              <p className="m-0" style={{...fonts.SM}}>
                {labels?.myData_gender}
              </p>
            </Row>
            <Row className="my-data-row">
              {selectedInsuranceData.genderCode}
            </Row>
            <Row className="account-data-row-title">
              <p className="m-0" style={{...fonts.SM}}>
                {labels?.myData_fiscalNumber}
              </p>
            </Row>
            <Row className="my-data-row">{selectedInsurancePerson.nif}</Row>
          </Column>
          <Column className="my-data-personal-right-column">
            <Row className="account-data-row-title">
              <p className="m-0" style={{...fonts.SM}}>
                {labels?.myData_address}
              </p>
            </Row>
            <Row className="my-data-row">
              {selectedInsuranceData.addr} <br />
              {selectedInsuranceData.postalcode} <br />
              {selectedInsuranceData.city}
            </Row>
            <Row className="account-data-row-title">
              <p className="m-0" style={{...fonts.SM}}>
                {labels?.myData_phone}
              </p>
            </Row>
            <Row className="my-data-row">
              {numberWithSpaces(selectedInsuranceData.phone)}
            </Row>
            {labels?.myData_cellphone_show === '1' && (
              <>
                <Row className="account-data-row-title">
                  <p className="m-0" style={{...fonts.SM}}>
                    {labels?.myData_cellphone}
                  </p>
                </Row>
                <Row className="my-data-row">
                  {numberWithSpaces(selectedInsuranceData.cellPhone)}
                </Row>
              </>
            )}
            <Row className="account-data-row-title">
              <p className="m-0" style={{...fonts.SM}}>
                {labels?.myData_email}
              </p>
            </Row>
            <Row className="my-data-row">{selectedInsuranceData.email}</Row>
          </Column>
        </Row>
        <Column className="my-data-adicional-help">
          <Row style={{...fonts.M, ...fonts.Bold}}>
            {labels?.myData_incorrectData}
          </Row>
          <Row style={{...fonts.M, ...fonts.Bold}}>
            {myDataFooterContactFromGroupId
              ? myDataFooterContactFromGroupId
              : labels?.myData_contact}
          </Row>
        </Column>
      </>
    );
  };
  return (
    <>
      <Column className="reimbursement-history-container ">
        <Row className="reimbursement-history-titlerow reimbursement-history-row">
          <Column className="my-data-title-column">
            <Header1
              className="reimbursement-history-heading1"
              style={{...fonts.XL, ...fonts.Bold}}>
              {labels?.myData_title}
            </Header1>
            <label style={{...fonts.M}}>{labels?.myData_subTitle}</label>
          </Column>
          <Column className="reimbursement-history-requestcolumn my-data-my-profile-column">
            {busFuncMap
              ? busFuncMap[selectedBu.buId]?.map((func: any) => {
                  if (
                    func?.isVisible &&
                    functionalitiesAliasMap.myProfile ===
                      func?.featureTemplateAlias
                  ) {
                    return (
                      <AppButton
                        variant="secondary"
                        onClick={() => history.push('/perfil')}
                        className="my-data-myprofile-button">
                        {labels?.myData_myProfile}
                      </AppButton>
                    );
                  }
                })
              : null}
          </Column>
        </Row>
        {busFuncMap
          ? busFuncMap[selectedBu.buId]?.map((func: any) => {
              if (
                func?.isVisible &&
                functionalitiesAliasMap.iban === func?.featureTemplateAlias
              ) {
                return (
                  <Row className="iban-filter-container">
                    {!showIban &&
                      !showIbanPatientSelected &&
                      ibanStrings?.ibanRefunds_form !== 'servio' && (
                        <>
                          <a
                            onClick={() => setshowIban(true)}
                            className="my-data-content-reimbursement-label"
                            style={{
                              ...fonts.M,
                              ...fonts.Bold,
                              color: buStyles?.primaryColor || colors.blue,
                              cursor: 'pointer',
                            }}>
                            {labels?.myData_iBANReimbursement}
                            <Icon
                              name={Icons.CHEVRON_DOWN}
                              width={'26'}
                              height={'26'}
                              color={buStyles?.primaryColor || colors.blue}
                            />
                          </a>
                        </>
                      )}
                    {(showIban || showIbanPatientSelected) &&
                      ibanStrings?.ibanRefunds_form !== 'servio' && (
                        <a
                          onClick={() => handleHideIban()}
                          className="my-data-content-reimbursement-label"
                          style={{
                            ...fonts.M,
                            ...fonts.Bold,
                            color: buStyles?.primaryColor || colors.blue,
                            cursor: 'pointer',
                          }}>
                          {labels?.myData_iBANReimbursement}
                          <Icon
                            className="my-data-content-reimbursement-chevron-up"
                            name={Icons.CHEVRON_DOWN}
                            width={'26'}
                            height={'26'}
                          />
                        </a>
                      )}
                  </Row>
                );
              }
            })
          : null}
        {!!selectedInsuranceData && !isLoading ? (
          <AppForm
            className="patient-validation-form-container"
            initialValues={{
              insurancePerson: insurancePerson, // alterei isto para as minhas options
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {}}>
            {(showIban || showIbanPatientSelected) &&
              ibanStrings?.ibanRefunds_form !== 'servio' && (
                <Row className="my-data-iban-row">
                  <IbanFilter
                    iBAN={iban}
                    updateIban={(iban: string) => updateIban(iban)}
                    accountOwner={
                      location?.state?.patientSelected?.name || titular?.name
                    }
                    userFilter={titular}
                    currentUser={user}
                    canSubmit={canSubmit}
                  />
                </Row>
              )}
            <Column className="my-data-validation-container">
              <Column className="patient-validation-box-column">
                <Row className="patient-validation-dropdown-row">
                  <AppFormSelectField
                    showErrorMessage
                    value={insurancePerson}
                    name={'insurancePerson'}
                    options={[...insurancePersonOptions]}
                    inputStyle={{color: `${buStyles.primaryColor}`}}
                    handleFormikContext={(formik) =>
                      handleFormikContext(formik)
                    }
                    onChange={(value) => {
                      setInsurancePerson(value);
                    }}
                  />
                </Row>
              </Column>
            </Column>
            {ibanStrings?.ibanRefunds_form === 'servio'
              ? renderSerbianForm()
              : renderDefaultForm()}
          </AppForm>
        ) : (
          <>{isLoading && <AppSpinner className="spinner-my-data" />}</>
        )}
        {notAuth &&
        ibanStrings?.ibanRefunds_bankAccountDataHolder === 'SUBSCRIBER' ? (
          <Column className="my-data-permission">
            <Row style={{...fonts.M}}>{labels?.myData_noPermission}</Row>
          </Column>
        ) : null}
      </Column>
      {showError && (
        <ModalTemplate
          type="error"
          show={showError}
          onHide={() => setShowError(false)}
          hideFooter={true}
          cross={true}>
          <p style={{color: colors.alertRed, fontWeight: 'bold'}}>
            {servicesLabels?.services_error}
          </p>{' '}
        </ModalTemplate>
      )}
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  wizard,
  globalStyles,
  busFuncMap,
  availableBus,
  titular,
  iban,
  busMap,
  ibanFilter,
  busGroupExceptions,
  updateRoutesNewSelectedPatient,
  bankAccountDataHolder,
  userBankAccountDataWasUpdated,
  servicesLabels,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.myData,
  wizard: wizard.value,
  labelsCreateRefund: strings.value.pt.createRefund,
  buStyles: globalStyles.value,
  busFuncMap: busFuncMap.value,
  availableBus: availableBus.value,
  titular: titular.value,
  iban: iban.value,
  busMap: busMap.value,
  ibanFilter: ibanFilter.value,
  ibanStrings: strings.value.pt.ibanRefunds,
  busGroupExceptions: busGroupExceptions.value,
  updateRoutesNewSelectedPatient: updateRoutesNewSelectedPatient.value,
  bankAccountDataHolder: bankAccountDataHolder.value,
  userBankAccountDataWasUpdated: userBankAccountDataWasUpdated.value,
  servicesLabels: strings.value.pt.services,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setIban: (value: any) => dispatch(setIban(value)),
  setTitular: (value: any) => dispatch(setTitular(value)),
  setIbanFilterOpenTrigger: (value: any) =>
    dispatch(setIbanFilterOpenTrigger(value)),
  setSelectedBu: (value: any) => dispatch(setSelectedBu(value)),
  setUpdateRoutesNewSelectedPatient: () =>
    dispatch(setUpdateRoutesNewSelectedPatient()),
});

export default compose(connect(mapStateToProps, mapDispatchToProps)(MyData));
